export const COLOR_CONNECTION = '#00A0FF';
export const COLOR_EMPLOYER = '#40C484';
export const COLOR_OWNER = '#7C4DFF';
export const COLOR_STATS = '#F3AE43';
